import { Lock } from "lucide-react";
import { AdminTopbar } from "@/components/admin/AdminLayout";
import { ModulePanel, DataTable } from "@/components/admin/AdminPrimitives";
import { useI18n } from "@/lib/i18n";

const PARTNERS = [
  { code: "P-AX2", country: "—", trust: "Élevé", contact: "Canal sécurisé", risk: "Faible", history: "12 contributions" },
  { code: "P-FK7", country: "—", trust: "Moyen", contact: "Canal sécurisé", risk: "Moyen", history: "4 contributions" },
  { code: "P-MH1", country: "—", trust: "Élevé", contact: "Canal sécurisé", risk: "Faible", history: "27 contributions" },
];

function Sources() {
  const { t } = useI18n();
  return (
    <>
      <AdminTopbar title={t("admin.sources.title")} subtitle={t("admin.sources.subtitle")} />
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <div className="rounded-md border border-alert/30 bg-alert/5 p-4 flex items-start gap-2 text-sm">
          <Lock className="h-4 w-4 text-alert mt-0.5 shrink-0" />
          <div>
            <div className="font-semibold text-alert">{t("admin.sources.alertTitle")}</div>
            <p className="text-foreground/85">{t("admin.sources.alertBody")}</p>
          </div>
        </div>
        <ModulePanel title={t("admin.sources.network")}>
          <DataTable
            columns={[
              t("admin.sources.col.code"),
              t("admin.sources.col.trust"),
              t("admin.sources.col.channel"),
              t("admin.sources.col.risk"),
              t("admin.sources.col.history"),
            ]}
            rows={PARTNERS.map((p) => [
              <span className="font-mono font-bold">{p.code}</span>,
              p.trust,
              p.contact,
              <span className={p.risk === "Élevé" ? "text-alert font-semibold" : ""}>{p.risk}</span>,
              <span className="text-muted-foreground">{p.history}</span>,
            ])}
          />
        </ModulePanel>
      </div>
    </>
  );
}

export default Sources;
